import { render, staticRenderFns } from "./ReceiveTags.vue?vue&type=template&id=4aa54804&scoped=true&"
import script from "./ReceiveTags.vue?vue&type=script&lang=js&"
export * from "./ReceiveTags.vue?vue&type=script&lang=js&"
import style0 from "./ReceiveTags.vue?vue&type=style&index=0&id=4aa54804&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa54804",
  null
  
)

export default component.exports